<template>
  <v-dialog v-model="showTestTypeModal" width="600" v-if="showTestTypeModal" persistent>
    <v-card>
      <v-card-title class="headline primary white--text" primary-title
        >{{ modalType == 'new' ? 'Create test type' : clickedItem.name }}
        <v-spacer></v-spacer>
        <v-btn @click="closeModal()" left text fab small color="white"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="testTypeEntryForm">
          <div class="mt-6">
            <v-row>
              <v-col sm="8" offset-sm="2">
                <v-text-field
                  outlined
                  dense
                  label="Name"
                  type="text"
                  :rules="[(v) => !!v || 'This field is required']"
                  class="required"
                  v-model="formData.name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="8" offset-sm="2">
                <v-text-field
                  outlined
                  dense
                  label="Prefix"
                  type="text"
                  :rules="[(v) => !!v || 'This field is required']"
                  class="required"
                  v-model="formData.prefix"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="8" offset-sm="2">
                <v-text-field
                  outlined
                  dense
                  label="Type"
                  type="text"
                  :rules="[(v) => !!v || 'This field is required']"
                  class="required"
                  v-model="formData.type"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-4">
        <v-btn v-if="modalType == 'edit'" color="error" text @click="deleteItem()"> <v-icon left>mdi-delete</v-icon> Delete </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal()" :disabled="saving"> Close </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" @click="modalType == 'edit' ? save() : create()" class="mx-4">
          Save
          <v-icon right>mdi-send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { TestType } from '@/views/TestTypes/data/TestType.js';
export default {
  props: ['showTestTypeModal', 'clickedItem', 'modalType'],
  data() {
    return {
      formData: null,
      saving: false
    };
  },
  watch: {
    showTestTypeModal(n) {
      if (n == false) this.$parent.showTestTypeModal = false;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    closeModal() {
      this.$parent.showTestTypeModal = false;
    },
    async save() {
      if (!this.$refs.testTypeEntryForm.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('testTypeStore/updateTestType', { testTypeData: this.formData, testId: this.formData.id })
        .then(() => {
          this.closeModal();
          this.$store.commit('SET_SNACKBAR', { open: true, text: 'Test type successfully edited', color: 'success' });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    async create() {
      if (!this.$refs.testTypeEntryForm.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('testTypeStore/createTestType', this.formData)
        .then((data) => {
          if (data) {
            this.closeModal();
            this.$store.commit('SET_SNACKBAR', { open: true, text: 'Test type successfully created', color: 'success' });
            this.$emit('testTypeStore/getTestTypes');
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    initData() {
      if (this.modalType == 'edit') {
        this.formData = JSON.parse(JSON.stringify(this.clickedItem));
      } else {
        this.formData = new TestType();
      }
    },
    deleteItem() {
      this.closeModal();
      this.$parent.showDeleteTestTypeModal = true;
    }
  }
};
</script>
